export default __webpack_public_path__ + "a395c4034612369692caa789cb04068e.png";